/**
 *
 * AccountLocked Component
 *
 */

import { stylize } from "@envestnet/envreact-component-library";
import classnames from "classnames";
import Exclamation from "images/Exclamation";
import React, { useCallback } from "react";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below

  /** Description of this prop */
  type: "ACCOUNT_LOCKED" | "INVALID_CODE" | "EMAIL_EXPIRED" | "ERROR";
}

export interface AccountLockedProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;
}

const defaultProps: DefaultProps = {
  type: "ACCOUNT_LOCKED",
};

type Props = InjectedProps & AccountLockedProps;

const AccountLocked = (props: Props) => {
  const { classes, style, className, formatMessage, innerRef, type } = props;

  const getHeader = useCallback(
    (t) => {
      let headerLabel;
      switch (t) {
        case "INVALID_CODE":
          headerLabel = formatMessage(messages.invalidCodeHeader);
          break;
        case "EMAIL_EXPIRED":
          headerLabel = formatMessage(messages.invalidCodeHeader);
          break;
        case "ERROR":
          headerLabel = formatMessage(messages.errorHeader);
          break;

        default:
          headerLabel = formatMessage(messages.header);
          break;
      }

      return headerLabel;
    },
    [type]
  );

  const getDesc = useCallback(
    (t) => {
      let descLabel;
      switch (t) {
        case "INVALID_CODE":
          descLabel = formatMessage(messages.invalidCodeDesc);
          break;
        case "EMAIL_EXPIRED":
          descLabel = formatMessage(messages.invalidCodeDesc);
          break;
        case "ERROR":
          descLabel = formatMessage(messages.errorDesc);
          break;

        default:
          descLabel = formatMessage(messages.description);
          break;
      }

      return descLabel;
    },
    [type]
  );

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div data-testid="account-locked-exclamation-symbol">
        <Exclamation />
        <span className={classnames(classes.header, "header-font-family")}>
          {getHeader(type)}
        </span>
      </div>
      <div
        className={classnames(classes.container, "header-text-font-family")}
        data-testid="account-locked-description"
      >
        {getDesc(type)}
      </div>
    </div>
  );
};

AccountLocked.defaultProps = defaultProps;

export default withIntl(stylize<Props, DefaultProps>(styles)(AccountLocked));
